module.exports = __webpack_public_path__ + "static/media/cq_ordinamento_asc b.d57383bf.svg";